import classNames from 'classnames';
import { Loader2 } from 'lucide-react';
import type { ReactNode } from 'react';

export function Loading({ color = '#CF5C10', size = 32 }: { color?: string; size?: number }) {
  return (
    <div className="absolute z-[99] bg-background/80 background-blur-sm left-0 right-0 top-0 bottom-0 flex flex-col justify-center items-center">
      <Loader2 className="animate-spin" color={color} size={size} />
    </div>
  );
}

export const Spin = ({
  children,
  loading,
  color,
  className
}: {
  children: ReactNode;
  loading: boolean;
  color?: string;
  className?: string;
}) => {
  return (
    <div className={classNames('relative w-full h-full', className)}>
      {loading ? (
        <div className={'absolute top-0 left-0 pt-10 w-full h-full flex justify-center items-center z-[9999]'}>
          <Loader2 className="animate-spin" color={color || '#CF5C10'} size={32} />
        </div>
      ) : (
        <div className="relative h-full">{children}</div>
      )}
    </div>
  );
};
